import { render, staticRenderFns } from "./PresentationsList.vue?vue&type=template&id=8f6bbb80&scoped=true&"
import script from "./PresentationsList.vue?vue&type=script&lang=js&"
export * from "./PresentationsList.vue?vue&type=script&lang=js&"
import style0 from "./PresentationsList.vue?vue&type=style&index=0&id=8f6bbb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6bbb80",
  null
  
)

export default component.exports